import { useTranslation } from 'react-i18next';
import { cn, LsbUtils, PaletteUtils } from '@shared/utils';
import { CategoryCard } from './categoryCard';
import { View } from '@widgets';
import { Text } from '@shared/widgets';

interface RecommendationsProps {
  className?: string;
}

export const Recommendations = (props: RecommendationsProps) => {
  const { t } = useTranslation('concierge');

  const categories = LsbUtils.getLifestyleCategories();
  return (
    <section
      className={cn(
        'flex flex-col gap-4 bg-white p-6 dark:bg-soft-black',
        PaletteUtils.isVcfcPalette && 'rounded-xl dark:border dark:border-gray-black',
        props.className,
      )}
    >
      <Text weight={PaletteUtils.getPaletteParam('semibold')} size={PaletteUtils.getPaletteParam('2xl', 'xl')}>
        {t('recommendations.title')}
      </Text>
      <View noData={!categories?.length} noDataText={t('recommendations.noData')}>
        <div className={cn('grid grid-cols-2 gap-4', 'max-lg:grid-cols-1', 'xl:grid-cols-3')}>
          {categories.map((category) => (
            <CategoryCard key={category.id} category={category} />
          ))}
        </div>
      </View>
    </section>
  );
};
